<template>
    <div class="invite-wrap">
        <div class="pc-wrap" v-if="device === 2">
            <div class="nav">
                <div class="nav-content">
                    <div class="lf-sec">
                        <div class="logo"></div>
                    </div>
                    <div class="rg-sec">
                        <div class="dl-btn fr" @click="dlClient">下载客户端</div>
                    </div>
                </div>
            </div>
            <div class="main-content">
                <div class="info1">
                    <div class="lf-sec">
                        <div class="img">
                            <div class="title">TA的邀请码</div>
                            <div class="code">{{ code }}</div>
                        </div>
                        <div class="btn" @click="copy">
                            <span class="icon"></span>
                            <span class="text">复制</span>
                        </div>
                    </div>
                    <div class="rg-sec">
                        <div class="img"></div>
                        <div class="btn">
                            <span class="icon"></span>
                            <span class="text" @click="dlClient">下载领取</span>
                        </div>
                    </div>
                </div>
                <div class="info2">
                    <div class="step1">
                        <span class="sp1">在电脑上安装乐速盒子</span>
                        <span class="sp2" @click="dlClient">立即下载</span>
                    </div>
                </div>
                <div class="rules">
                    <div class="title"></div>
                    <div class="content">
                        <p>1.活动时间内，用户每通过个人所属邀请码邀请未注册的用户完成一次实名认证即视为完成一次活动。</p>
                        <p>2.奖励将于任务完成后一个工作日内下发，用户可通过客户端内活动详情页下方查看奖励发放进度。</p>
                        <p>3.奖励直接发放到账户余额，该奖励不可提现或转赠。</p>
                        <p>4.用户进行分享时应使用个人的邀请码，并通过合法合规途径进行推广；用户应避免误发他人邀请码或通过第三方途径刷单，不合规行为造成奖励发放错误或账号异常的后果，将由用户自行承担。</p>
                        <p>5.本次活动单个邀请码限制使用20次，一个新用户仅可通过邀请码获得一次奖励。</p>
                        <p>6.该活动最终解释权归乐速盒子官方所有，如有疑问请咨询客服</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="mobile-wrap" v-if="device === 1">
            <div class="info1">
                <div class="lf-sec">
                    <div class="img"></div>
                </div>
                <div class="rg-sec">
                    <div class="img">
                        <div class="title">TA的邀请码</div>
                        <div class="code">{{ code }}</div>
                    </div>
                    <div class="btn" @click="copy">
                        <span class="icon"></span>
                        <span class="text">复制</span>
                    </div>
                </div>
            </div>
            <div class="info2">
                <div class="step1">
                    <div class="title"></div>
                    <div class="txt1">电脑搜索“乐速盒子”</div>
                    <div class="txt2">进入官网:box.steamf.cn 下载安装</div>
                    <div class="btn" @click="copy('website')">
                        <span class="icon"></span>
                        <span class="text">复制网址</span>
                    </div>
                </div>
            </div>
            <div class="rules">
                <div class="title"></div>
                <div class="content">
                    <p>1.活动时间内，用户每通过个人所属邀请码邀请未注册的用户完成一次实名认证即视为完成一次活动。</p>
                    <p>2.奖励将于任务完成后一个工作日内下发，用户可通过客户端内活动详情页下方查看奖励发放进度。</p>
                    <p>3.奖励直接发放到账户余额，该奖励不可提现或转赠。</p>
                    <p>4.用户进行分享时应使用个人的邀请码，并通过合法合规途径进行推广；用户应避免误发他人邀请码或通过第三方途径刷单，不合规行为造成奖励发放错误或账号异常的后果，将由用户自行承担。</p>
                    <p>5.本次活动单个邀请码限制使用20次，一个新用户仅可通过邀请码获得一次奖励。</p>
                    <p>6.该活动最终解释权归乐速盒子官方所有，如有疑问请咨询客服</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getDictConfig } from '@/http/api/common'

export default {
    name: 'Invite',
    data() {
        return {
            code: '',
            dl: '',
            device: -1 // 1--》移动端，2--》PC端
        }
    },
    created() {
        this.code = this.$route.query.code || ''
        this.appDom = document.getElementById('app')
        this.appDom.style.height = 'auto'
        document.documentElement.style.height = 'auto'
        this.getDl()
    },
    mounted() {
        const device = this.$Utils.judgeDevice()
        if (device !== 'other') {
            this.device = 1
            this.setSize()
        } else {
            this.device = 2
        }
    },
    beforeDestroy() {
        document.documentElement.style.height = '100%'
        this.appDom.style.height = '100%'
    },
    methods: {
        setSize() {
            const html = document.documentElement
            const screenWidth = html.clientWidth
            if (screenWidth >= 750) {
                html.style.fontSize = '100px'
            } else {
                html.style.fontSize = screenWidth / 7.5 + 'px'
            }
        },
        getDl() {
            const query = {
                page: 1,
                size: 1,
                type: 'INVITE_ACT_PAGE_DL'
            }
            getDictConfig(query).then(res => {
                if (res.code == 200 && this.$Utils.isObject(res.data) && Array.isArray(res.data.list) && res.data.list.length) {
                    if (res.data.list[0].value) {
                        this.dl = res.data.list[0].value
                    }
                }
            })
        },
        dlClient() {
            window.open(this.dl, '_self')
        },
        copy(payload) {
            if (this.code) {
                this.$Utils.copy(this.code)
            }

            if (payload === 'website' && this.device === 1) {
                this.$Utils.copy('https://box.steamf.cn')
            }
        }
    }
}
</script>
<style lang="less" scoped>
.pc-wrap {
    background: url(~@/assets/invite/invite-bg-pc.jpg) no-repeat center/100%;
    padding-top: 70px;
    background-position-x: center;
    background-position-y: 0;
    background-size: 1920px 3272px;

    .nav {
        position: fixed;
        z-index: 1;
        left: 0;
        top: 0;
        width: 100%;
        height: 70px;
        padding-top: 10px;
        background: rgba(28, 31, 34, 1);

        .nav-content {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .lf-sec {
                .logo {
                    width: 195px;
                    height: 53px;
                    background: url(~@/assets/invite/logo2.png) no-repeat center center;
                }
            }

            .rg-sec {
                .dl-btn {
                    .button-linear();
                    width: 148px;
                    height: 46px;
                    line-height: 46px;
                    text-align: center;
                    font-weight: bold;
                    font-size: 16px;
                    border-radius: 23px;
                    color: @bg-color-00;
                }
            }
        }
    }

    .main-content {
        width: 1216px;
        margin: 627px auto 0;

        .info1 {
            padding-top: 54px;
            padding-bottom: 75px;
            margin-bottom: 54px;
            display: flex;
            justify-content: center;

            .lf-sec,
            .rg-sec {
                width: 368px;

                .img {
                    height: 200px;
                    margin-bottom: 20px;
                    overflow: hidden;

                    .title {
                        margin: 65px auto 20px;
                        font-size: 20px;
                        text-align: center;
                        color: #4c110c;
                    }

                    .code {
                        font-weight: 900;
                        font-size: 30px;
                        text-align: center;
                        color: #4c110c;
                    }
                }

                .btn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 60px;
                    background: url(~@/assets/invite/btn-bg.png) no-repeat center/100%;
                    cursor: pointer;

                    &:hover {
                        background-image: url(~@/assets/invite/btn-bg-h.png);
                    }

                    .text {
                        font-weight: 700;
                        font-size: 20px;
                        color: #4c110c;
                    }

                    .icon {
                        position: relative;
                        top: 1px;
                    }
                }
            }

            .lf-sec {
                .img {
                    background: url(~@/assets/invite/info-bg.png) no-repeat center/100%;
                }

                .icon {
                    margin-right: 6px;
                    width: 21px;
                    height: 20px;
                    background: url(~@/assets/invite/copy-icon.png) no-repeat center/100%;
                }
            }

            .rg-sec {
                margin-left: 20px;
                .img {
                    background: url(~@/assets/invite/three-day.png) no-repeat center/100%;
                }

                .icon {
                    margin-right: 6px;
                    width: 18px;
                    height: 19px;
                    background: url(~@/assets/invite/download-icon.png) no-repeat center/100%;
                }
            }
        }

        .info2 {
            position: relative;
            margin-bottom: 55px;
            width: 100%;
            height: 1603px;
            background: url(~@/assets/invite/exchange-intro.png) no-repeat center/100%;

            .step1 {
                position: absolute;
                top: 279px;
                left: 445px;
                height: 40px;
                display: flex;
                align-items: center;

                .sp1 {
                    font-size: 20px;
                    color: #fff3e6;
                }

                .sp2 {
                    cursor: pointer;
                    margin-left: 22px;
                    color: #6e1614;
                    text-align: center;
                    line-height: 40px;
                    font-size: 20px;
                    font-weight: bold;
                    width: 120px;
                    height: 40px;
                    background: linear-gradient(0deg, #ffbb74, #ff834e);

                    &:hover {
                        background: linear-gradient(to bottom, #ff9c71, #ffc88f);
                    }
                }
            }
        }

        .rules {
            margin: 0 auto;
            width: 1055px;

            .title {
                margin: 0 auto 37px;
                width: 555px;
                height: 88px;
                background: url(~@/assets/invite/rules.png) no-repeat center/100%;
            }

            .content {
                padding-bottom: 10px;

                p {
                    color: #fff3e6;
                    font-size: 20px;
                    text-align: left;
                    line-height: 42px;
                }
            }
        }
    }
}

.mobile-wrap {
    width: 100%;
    padding-top: 4.23rem;
    padding-bottom: 0.4rem;
    background: #fff url(~@/assets/invite/invite-bg-mobile.jpg) no-repeat top center;
    background-size: 100% auto;

    .info1 {
        display: flex;
        padding: 0.34rem 0 0.48rem;
        justify-content: center;

        .lf-sec,
        .rg-sec {
            width: 3rem;
        }

        .lf-sec {
            margin-right: 0.16rem;
            .img {
                height: 2.06rem;
                background: url(~@/assets/invite/vip-info-bg.png) no-repeat center/100%;
            }
        }

        .rg-sec {
            .img {
                padding-top: 0.39rem;
                width: 3rem;
                height: 1.43rem;
                background: url(~@/assets/invite/code-bg.png) no-repeat center/100%;

                .title {
                    font-size: 0.2rem;
                    text-align: center;
                    color: #4c110c;
                }

                .code {
                    margin-top: 0.14rem;
                    font-weight: bold;
                    font-size: 0.3rem;
                    text-align: center;
                    color: #4c110c;
                }
            }

            .btn {
                margin-top: 0.1rem;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 0.52rem;
                background: linear-gradient(0deg, #ff834e, #ffbb74);

                .text {
                    font-weight: 700;
                    font-size: 0.24rem;
                    color: #4c110c;
                }

                .icon {
                    margin-right: 0.09rem;
                    position: relative;
                    top: 1px;
                    width: 0.23rem;
                    height: 0.23rem;
                    background: url(~@/assets/invite/copy-icon.png) no-repeat center/100%;
                }
            }
        }
    }

    .info2 {
        padding-top: 1.58rem;
        margin: 0 auto;
        width: 6.9rem;
        height: 15.53rem;
        background: url(~@/assets/invite/m-exchange-intro.png) no-repeat center/100%;

        .step1 {
            .title {
                margin: 0 auto 0.18rem;
                width: 1.06rem;
                height: 0.3rem;
                background: url(~@/assets/invite/m-step1-title.png) no-repeat center/100%;
            }

            .txt1,
            .txt2 {
                font-size: 0.24rem;
                text-align: center;
                color: #fff3e6;
                line-height: 1.5;
                margin-bottom: 0.06rem;
            }

            .txt2 {
                margin-bottom: 0.16rem;
            }

            .btn {
                margin: 0 auto;
                text-align: center;
                line-height: 0.45rem;
                width: 1.41rem;
                height: 0.45rem;
                background: linear-gradient(0deg, #ffbb74, #ff834e);
                font-weight: 700;
                font-size: 0.24rem;
                color: #6e1614;
            }
        }
    }

    .rules {
        .title {
            margin: 0.46rem auto 0.42rem;
            width: 4.94rem;
            height: 0.54rem;
            background: url(~@/assets/invite/m-rules.png) no-repeat center/100%;
        }

        .content {
            padding: 0 0.45rem;

            p {
                font-size: 0.2rem;
                color: #fff3e6;
                line-height: 0.4rem;
            }
        }
    }
}
</style>
